import React, { useState, useRef } from "react";
import Squares from "./Squares";

const GridBackground = ({ children, className = '' }) => {
    const [mousePosition, setMousePosition] = useState(null);
    const parentRef = useRef(null);

    const handleMouseMove = (event) => {
        const parent = parentRef.current;
        if (!parent) return;
        const rect = parent.getBoundingClientRect();
        setMousePosition({
            x: event.clientX - rect.left,
            y: event.clientY - rect.top,
        });
    };

    const handleMouseLeave = () => {
        setMousePosition(null);
    };

    return (
        <div
            ref={parentRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            className={`relative w-full h-full overflow-hidden ${className}`}
        >
            <div className="absolute inset-0 w-full h-full pointer-events-none">
                <Squares
                    mousePosition={mousePosition}
                    speed={0.5}
                    squareSize={40}
                    direction='diagonal'
                    borderColor='rgba(128,128,128,0.15)'
                    hoverFillColor='rgba(200,200,200,0.7)'
                />
            </div>
            <div className="relative z-10 h-full">{children}</div>
        </div>
    );
};

export default GridBackground;
